import { site } from '@/lib/site'

type SeoProps = {
  /** Título da página, sem o nome do site. Omitir na página inicial. */
  title?: string
  description?: string
  /** Caminho canônico, ex.: "/propostas/fim-da-reeleicao". */
  path?: string
  /** Páginas privadas (conta, painel, formulários) não devem ser indexadas. */
  noIndex?: boolean
}

/** Metadados da página. React 19 move <title>, <meta> e <link> para o <head>. */
export function Seo({ title, description, path, noIndex }: SeoProps) {
  const fullTitle = title ? `${title} · ${site.name}` : `${site.name} · ${site.tagline.replace(/\.$/, '')}`
  return (
    <>
      <title>{fullTitle}</title>
      {description ? <meta name="description" content={description} /> : null}
      {path ? <link rel="canonical" href={`${site.url}${path}`} /> : null}
      {noIndex ? <meta name="robots" content="noindex" /> : null}
    </>
  )
}
